import { AxiosResponse } from "axios";
import {
    apiGet,
    apiPost,
    apiDelete,
    getGlobalStates,
} from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { GET_SOCIAL_INTEGRATIONS, CREATE_MICROSOFT, UPDATE_MICROSOFT, DELETE_MICROSOFT } from "./identityProviderPath";
import usermgtStore from "../usermgtStore";
import { usermgtSliceActions } from "../usermgtSlice";
import { socialIdentityProviderSliceActions } from "../socialIdentityProviderSlice";
import {
    isActiveServer,
    UpdateSocialIdentityProvider,
    DeleteSocialIdentityProvider,
    AddSocialIdentityProvider,
    SocialIdentityProviders,
    SocialIdentityProviderStatus,
    SocialIdentityProviderConfig,
    getRedirectURL,
    SOCIAL_IDENTITY_PROVIDER_ERROR_KEY,
} from "userful-chronos-app-common-js/dist/models/usermgt/socialIdentityProviders";
import { toast } from "react-toastify";
import { ConfirmationToastContentStore } from "../../../Container/ConfirmationToastContentStore";

const errorHandler = (err) => {
    console.debug("Error calling init app api ");
    console.debug(err);
};

const getError = (response: any) => {
    return {
        success: false,
        arg: response.data.arg ? response.data.arg : "",
        errorCode: response.data.errorCode ? response.data.errorCode : "",
        moduleID: response.data.moduleID ? response.data.moduleID : "",
        severity: response.data.severity ? response.data.severity : "",
        msg: response.data.unlocalizedMsg ? response.data.unlocalizedMsg : "",
    };
};

export const checkReponseIsValid = (name: string, response: AxiosResponse): boolean => {
    if (response.status >= 400) {
        console.log(`${name} error: ${response.status}`);
        return false;
    }
    if (!response.data || response.data.severity !== "SUCCESS") {
        console.log(`${name} empty response`);
        return false;
    }
    return true;
};

export const getSocialIdentityProviderDataFromServer = (token: string) => {
    const t1 = getGlobalStates().host + GET_SOCIAL_INTEGRATIONS;

    apiGet(t1, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            if (!checkReponseIsValid("authorize", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                usermgtStore.dispatch(socialIdentityProviderSliceActions.setSaveBool(false));
                return;
            }
            usermgtStore.dispatch(
                socialIdentityProviderSliceActions.setSocialIdentityProvider(
                    getProvidersAfterValidationCheck(response.data.arg),
                ),
            );
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`receive authorize`, response.data);
        })
        .catch(() => console.warn("failed"));
};

export const addSocialIdentityProviderDataToServer = (token: string, data: AddSocialIdentityProvider) => {
    const t1 = getGlobalStates().host + CREATE_MICROSOFT;

    apiPost(t1, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            if (!checkReponseIsValid("configure social ", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                return;
            }
            usermgtStore.dispatch(
                socialIdentityProviderSliceActions.setSocialIdentityProvider(
                    getProvidersAfterValidationCheck(response.data.arg),
                ),
            );
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setOverlay(false));
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setSaveBool(false));

            const displaySuccess = ConfirmationToastContentStore(data.config[0].alias, "Save");
            toast(displaySuccess, { containerId: "confirmationContainer" });
        })
        .catch(() => console.warn("failed"));
};

export const updateSocialIdentityProviderDataToServer = (token: string, data: UpdateSocialIdentityProvider) => {
    const t1 = getGlobalStates().host + UPDATE_MICROSOFT;

    apiPost(t1, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            if (!checkReponseIsValid("update Microsoft ", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                return;
            }
            usermgtStore.dispatch(
                socialIdentityProviderSliceActions.setSocialIdentityProvider(
                    getProvidersAfterValidationCheck(response.data.arg),
                ),
            );
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setOverlay(false));
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setSaveBool(false));

            const displaySuccess = ConfirmationToastContentStore(data.id.value, "Edit");
            toast(displaySuccess, { containerId: "confirmationContainer" });
        })
        .catch(() => console.warn("failed"));
};

export const deleteSocialIdentityProviderDataFromServer = (token: string, data: DeleteSocialIdentityProvider) => {
    const t1 = getGlobalStates().host + DELETE_MICROSOFT;

    apiPost(t1, data, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then((response) => {
            if (!checkReponseIsValid("authorize", response)) {
                const getErrorMessage = getError(response);
                usermgtStore.dispatch(usermgtSliceActions.changeError(getErrorMessage));
                usermgtStore.dispatch(usermgtSliceActions.changeErrorBool(true));
                return;
            }
            usermgtStore.dispatch(
                socialIdentityProviderSliceActions.setSocialIdentityProvider(
                    getProvidersAfterValidationCheck(response.data.arg),
                ),
            );
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setLoadBool(false));
            usermgtStore.dispatch(socialIdentityProviderSliceActions.setSaveBool(false));
            console.debug(`receive authorize`, response.data);
        })
        .catch(() => console.warn("failed"));
};

export const getProvidersAfterValidationCheck = (providerData): SocialIdentityProviders => {
    let updatedDataProviders: SocialIdentityProviderStatus[] = providerData.providers.map((s) => {
        let activeConfig: SocialIdentityProviderConfig = s.provider.config.find((c: SocialIdentityProviderConfig) =>
            isActiveServer(c.redirectURL),
        );
        let secondaryConfig: SocialIdentityProviderConfig = s.provider.config.find(
            (c: SocialIdentityProviderConfig) => !isActiveServer(c.redirectURL),
        );
        if (!activeConfig) {
            activeConfig = s.provider.config[0];
            activeConfig = { ...activeConfig, redirectURL: getRedirectURL(getGlobalStates().host, activeConfig.alias) };
            if (s.provider.config.length > 1) secondaryConfig = s.provider.config[1];
            let updatedConfig: SocialIdentityProviderConfig[] = [];
            updatedConfig.push(activeConfig);
            if (s.provider.config.length > 1) updatedConfig.push(secondaryConfig);
            return {
                ...s,
                provider: { ...s.provider, config: updatedConfig },
                error: true,
                errorKey: "INVALID_MICROSOFT_CONFIG" as SOCIAL_IDENTITY_PROVIDER_ERROR_KEY,
                errorMassage: "",
            };
        }
        return s;
    });
    const updatedData: SocialIdentityProviders = { providers: updatedDataProviders };
    return updatedData;
};
